<template>
  <div>
    <div v-if="loading" class="flex items-center justify-center py-16">
      <HoapIcon icon="Loading" class="w-12 h-12" />
    </div>
    <div v-else-if="videos && videos.length" class="grid grid-cols-4 gap-x-8 gap-y-16">
      <LibraryCard
        v-for="(video, index) in videos"
        :key="video.title + index"
        v-bind="video"
        :image-url="video.image?.url ?? ''"
        :image-alt="video.imageAlt ?? ''"
        :video-type="video.type"
        type="video" />
    </div>
    <div v-else class="text-center md:text-lg font-light text-gray-100">
      Looks like we haven't uploaded any videos yet. Check back later to see what we upload!
    </div>
  </div>
</template>

<script setup lang="ts">
  import { Ref } from 'vue'
  import { useQuery } from '@vue/apollo-composable'

  import { GET_ORIGINALS } from '../queries'

  const { result, loading } = useQuery(GET_ORIGINALS)
  const videos: Ref<
    Array<{ title: string; slug: string; type: string; imageAlt: string; image: { url: string }; vimeoVideoId: string }>
  > = computed(() => result.value?.originals)
</script>
